import { InterpolatePrismicDocumentInvalidFields } from './InterpolatePrismicDocumentInvalidFields'

export class InterpolatePrismicDocumentError extends Error {
  invalidFields: InterpolatePrismicDocumentInvalidFields

  constructor({ invalidFields }: { invalidFields: InterpolatePrismicDocumentInvalidFields }) {
    let message = 'The following fields had invalid placeholders and filters:\n'
    Object.keys(invalidFields)
      .sort()
      .forEach(fieldName => {
        const field = invalidFields[fieldName]
        message += `  ${fieldName}\n`
        if (field.invalidPlaceholders.length) {
          message += `    placeholders: ${field.invalidPlaceholders.join(',')}\n`
        }
        if (field.invalidFilters.length) {
          message += `    filters: ${field.invalidFilters.join(',')}\n`
        }
      })
    message = message.trim()
    super(message)
    this.invalidFields = invalidFields
  }
}
